module.exports = __webpack_public_path__ + "img/new-h-hmini.cbc15327.png";